import { type EventOrTimeslot, isEvent, type WebUser } from 'types';
import useStyles from './DayEvents.styles';
import clsx from 'clsx';
import { ClassNameMap } from '@mui/material';
import { useWebUserContext } from 'contexts';
import {isEventOwner} from 'utils';

const getColorClassName = (
  currentWebUser: WebUser,
  eventOrTimeslot: EventOrTimeslot,
  classes: ClassNameMap,
): string => {
  if (isEvent(eventOrTimeslot)) {
    if (isEventOwner(eventOrTimeslot, currentWebUser)) {
      return classes.ownedEvent;
    } else {
      return classes.guestEvent;
    }
  } else {
    return classes.busyEvent;
  }
};

type DayEventPureProps = {
  classNames: string[];
};

const DayEventPure = ({ classNames }: DayEventPureProps): JSX.Element => (
  <div className={clsx(classNames)} data-testid="day-event-or-timeslot" />
);

type DayEventProps = {
  eventOrTimeslot: EventOrTimeslot;
};

const DayEvent = ({ eventOrTimeslot }: DayEventProps): JSX.Element => {
  const { webUser } = useWebUserContext();
  const classes = useStyles();
  const colorClassName = getColorClassName(webUser, eventOrTimeslot, classes);

  return <DayEventPure classNames={[classes.dayEvent, colorClassName]} />;
};

export default DayEvent;
